<template>
    <div>
        <VuePhoneNumberInput 
            v-model="phone" 
            :translations="translations" 
            default-country-code="FR" 
            :show-code-on-list="true" 
            :clearable="true"
            :error="error"
            :preferred-countries="['FR', 'BE', 'DE']"
            @update="setPhoneNumber"/>

            <input type="hidden" :value="!error" :name="name + '_is_valid'">
    </div>
</template>

<script>

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


export default {
    name: 'phone-number',
    components: {
        VuePhoneNumberInput,
    },
    props: {
        name: null,
    },
    data(){
       return {
           phone: null,
           translations: {
                countrySelectorLabel: 'Code pays',
                countrySelectorError: 'Choisir un pays',
                phoneNumberLabel: 'Numéro de téléphone',
                example: 'Numéro de téléphone invalide - Exemple :'
            },
            element: null,
            error: false,
       }
    },
    mounted(){
        if(document.getElementById(this.name)){
            this.element = document.getElementById(this.name);
            this.phone = this.element != null && this.element.value.length > 0 ? this.element.value : this.phone;
        }
    },
    methods: {
        setPhoneNumber(e){
            this.element.value = e.formattedNumber;
            this.error = !e.isValid;

            if(!e.phoneNumber){
                this.error = false;
                this.element.value = null;
                this.phone = null;
            }
        }
    },
   
}

</script>